//#region Styles
import { StyledHeader } from "views/Recursos/styles";
//#endregion
//#region Components
import Superheader from "./Superheader/Superheader";
import Filters from "./Filters/Filters";
import FilterHeader from "./FilterHeader/FilterHeader";
//#endregion

const Header = ({
    isLibrarian,
    loadingRequest, 
    data, filters,
    serviceList,
    openShowDialogResourceForm,
    allFilterFieldsWereFilled,
    paginator, searchedFilters,
    resetUI
}) => {
    return (
        <StyledHeader>
            <Superheader 
                resourceTypes={data.resourceTypes}
                openShowDialogResourceForm={openShowDialogResourceForm}/>
            <Filters 
                loadingRequest={loadingRequest}
                isLibrarian={isLibrarian}
                filters={filters}
                header={
                <FilterHeader 
                    searchedFilters={searchedFilters}
                    serviceList={serviceList}
                    paginator={paginator}/>}
                resetUI={resetUI}
                data={data}
                allFilterFieldsWereFilled={allFilterFieldsWereFilled}
                triggerServiceFilling={serviceList.triggerFilling}/>
        </StyledHeader>
    );
}

export default Header;